module.exports = __webpack_public_path__ + "wave.svg?2cb3c8d4588842b8d77029eb14aa4862";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wave.svg
// module id = 82
// module chunks = 0